import type { ParentAttendanceMark } from '../../types/attendance';

/**
 * One mark, as a pill.
 *
 * Its own component because the register is shown in three places — the history
 * table, the report's daily table and its CSV — and three copies of the same
 * nested ternary is three places for `LEAVE` to be forgotten and rendered as
 * "Late" (CLAUDE.md §3).
 */

export const ATTENDANCE_MARK_LABEL: Record<ParentAttendanceMark, string> = {
  PRESENT: 'Present',
  ABSENT: 'Absent',
  LATE: 'Late',
  LEAVE: 'On leave',
};

/** Leave reads as its own thing, not as an absence: it was asked for and given. */
const TONE: Record<ParentAttendanceMark, string> = {
  PRESENT: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/20',
  ABSENT: 'bg-rose-500/10 text-rose-700 dark:text-rose-400 border-rose-500/20',
  LATE: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20',
  LEAVE: 'bg-indigo-500/10 text-indigo-700 dark:text-indigo-400 border-indigo-500/20',
};

export function AttendanceStatusPill({ status }: { status: ParentAttendanceMark }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold ${TONE[status]}`}
    >
      {ATTENDANCE_MARK_LABEL[status]}
    </span>
  );
}
